<template>
  <div class="app-container">
    <Title :data="data"></Title>
    <Batch
      title="作业"
      text="作业"
      :list="form.excellent_homework"
      style="margin-bottom: 20px"
      @refresh="getDetail"
    />
    <Batch
      title="试卷"
      text="试卷"
      :list="form.excellent_answer"
      style="margin-bottom: 20px"
      @refresh="getDetail"
    />
    <!-- <Batch
      title="成绩表"
      text="成绩表"
      :list="form.school_report"
      style="margin-bottom: 20px"
      @refresh="getDetail"
    /> -->
    <div style="display: flex; justify-content: center">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>   

    <el-dialog
      title="批量操作"
      :visible.sync="batchAuthDialogVisible"
      width="60%"
      @close="handleClose"
    >
      <el-form ref="form" label-width="100px">
        <el-form-item label="原因">
          <el-input
            v-model="rejectReason"
            :placeholder="`请输入原因`"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="batchAuthBtnLoading"
            @click="handleBatchAuth(1)"
            >通过</el-button
          >
          <el-button
            type="warning"
            :loading="batchAuthBtnLoading"
            @click="handleBatchAuth(2)"
            >驳回</el-button
          >
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Batch from "@/components/Batch/index.vue";
import request from "@/utils/request";
export default {
  components: {
    Batch,
  },
  data() {
    return {
      form: {},
      listQuery: {
        page: 1,
        limit: 10,
        type: null,
        class_course_id: null,
      },
      selected: false,
      batchAuthDialogVisible: false,
      batchAuthBtnLoading: false,
      rejectReason: null,
      data:{}
    };
  },
  created() {
    this.listQuery.type = this.$route.query.type;
    this.listQuery.class_course_id = this.$route.query.class_course_id;
    this.data=JSON.parse(this.$route.query.data) 
    localStorage.setItem("classdata", JSON.stringify(this.data));
    this.form = {
      excellent_homework: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "excellent_homework",
        data: [],
      },
      excellent_answer: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "excellent_answer",
        data: [],
      },
      school_report: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "school_report",
        data: [],
      },
    };
    this.getDetail();
  },
  methods: {
    getDetail() {
      request({
        url: "/api/schoolend/eduAdmin/dataDetail",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        if (response.data) {
          this.form = response.data;
          this.$forceUpdate(); //强制更新
        }
      });
    },
    handlerTap(v) {
      this.selected = !this.selected;
    },
    handleBatchAuth() {},
    handleClose() {
      this.batchAuthDialogVisible = false;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  margin-bottom: 20px;
}
.content {
  width: 50%;
  margin: 0 auto;
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .bottom_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 100px;
  }
  .bottom {
    display: flex;
  }
}
</style>
